import httpStatusCode from '../../../../api-server/constants/httpStatusCode';
import axios from 'axios';
import { API_CALL_STATUS } from '../../../reducers/status';
import { setBranchCodesApiStatus } from '../../../actions/sizotsaFuneralClaim/referenceData';
import { getUploadDocumentsSummary } from '../../../selectors/sizotsaFuneralClaim/uploadDocuments';
import { getClaimentDetailsForm, getClaimentDetailsSummary } from '../../../selectors/sizotsaFuneralClaim/claimentDetails';
import { getDeceasedDetailsSummary, getDecesedId } from '../../../selectors/sizotsaFuneralClaim/deceasedDetails';

export const claimMailService = (store, next, action) => {
    const state=store.getState();
    console.log(action,'action');
    (async () => {
        try{
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.PENDING,apiFor:'finalEmail'}))
            const {firstName,middleName,lastName,mobileNumber,email,policyNumber}= getClaimentDetailsForm(state)
            const decesedId=getDecesedId(state)
            const buyRef=action?.value
            const productLabel='Sizosta-Funeral-Claim'
            // const monthlyQuoteAllproducts = getFinalQuotation(state)
            const referenceNumber=policyNumber?.value
            // const premiumFrequency = 'Monthly'
            const claimentDetails=getClaimentDetailsSummary(state) 
            const deceasedDetails=getDeceasedDetailsSummary(state) 
            const uploadDocuments=getUploadDocumentsSummary(state)
        const claimSummary = [
            { title: 'Claiment Details', data: claimentDetails },
            { title: 'Deceased Details', data: deceasedDetails },
            {title: 'Documents',data:uploadDocuments},
        ];
        console.log(decesedId,'decesedId');
        const userDataFields = [...claimSummary]

        const sampleRequestBody = {
            firstName:firstName?.value,
            lastName:lastName?.value,
            contactNumber:mobileNumber?.value,
            subject:`Web: ${productLabel} : ${firstName?.value+' '+lastName?.value} - REF: ${decesedId?.value}`,
            userDataFields,
            templateType:"SZ_FUNERAL_CLAIM_BUSINESS",
            // "FUNERAL_CLAIM_BUISENESS",
            // FUNERAL_PURCHASE_BUISENESS
            monthlyPremium: null,
            yearlyPremium:null,
            // email:"BW_KMF_BUSSINESS_MAIL",
            email:"spatel5@oldmutual.com, skamble@oldmutual.co.bw",
        }
       
        const sampleRequestCustomer = {
            firstName:firstName?.value,
            lastName:lastName?.value,
            contactNumber:mobileNumber?.value,
            subject:`Web: ${productLabel} : ${firstName?.value+' '+lastName?.value} - REF: ${decesedId?.value}`,
            userDataFields,
            templateType:"SZ_FUNERAL_CLAIM_CUSTOMER",
            monthlyPremium: null,
            yearlyPremium:null,
            email:email?.value,
        }
        const response = await sendEmailNotification(sampleRequestBody);
        const responseCustomer = await sendEmailNotification(sampleRequestCustomer);
        console.log(response,responseCustomer,'response');
        if (response && response.status === httpStatusCode.OK) {
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.SUCCESS,apiFor:'finalEmail'}));
        } else {
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.FAILURE,apiFor:'finalEmail'}));
        }
    }
        catch(error){
            store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.FAILURE,apiFor:'finalEmail'}));
        }
    })();
    return next(action);
};

export const sendEmailNotification = async (requestBody) => {
    try {
        const response = await axios({
            url: 'om-api/submit-notification/submitNotificationEmail',
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            data: requestBody,
        });
        console.log(response);
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};